"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSelectedCrewOn = exports.onLeave = exports.onEnter = void 0;
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageUiBuyStuff_sidecar_1 = require("@voyage/ui/voyageUiBuyStuff-sidecar");
var voyageUiSubsystem_sidecar_1 = require("@voyage/ui/voyageUiSubsystem-sidecar");
function onEnter(obj) {
    // swapItemHere(obj, true)
    if (voyagePicker_sidecar_1.voyagePicker.get().selectedCrew === obj) {
        // voyageUiBuyStuff.setOpen(true)
    }
}
exports.onEnter = onEnter;
function onLeave(obj) {
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
    voyageUiBuyStuff_sidecar_1.voyageUiBuyStuff.setOpen(false);
}
exports.onLeave = onLeave;
function onSelectedCrewOn(obj) {
    if (voyageUiBuyStuff_sidecar_1.voyageUiBuyStuff.get().isOpen) {
        voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
    }
    else {
        // voyageUiSubsystem.setOpen(true, obj.tile)
    }
}
exports.onSelectedCrewOn = onSelectedCrewOn;
